import React from 'react';
import Radium from 'radium';
import moment from 'moment';
import JumperScrollbar from '../../../JumperScrollbar';
import ProjectGridElement from './ProjectGridElement/ProjectGridElement';
import Style from './ProjectListGrid.style';

const sortCompare = (a, b) => {
  const sort = JSON.parse(localStorage.getItem('projects_table_sort')) || {
    key: 'name',
    direction: 'asc',
  };

  const { key, direction } = sort;
  if (!a[key] || !b[key]) {
    if (a[key] && !b[key]) {
      return 1;
    }
    if (!a[key] && b[key]) {
      return -1;
    }
    return 0;
  }
  const valueA = a[key].toString().toLowerCase();
  const valueB = b[key].toString().toLowerCase();
  if (direction === 'asc') {
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  }
  if (valueA > valueB) {
    return -1;
  }
  if (valueA < valueB) {
    return 1;
  }
  return 0;
};

const renderProjectList = (props) => {
  const { batchEdit, onElementClick, selected, projects } = props;
  const sortedProjects = projects.sort(sortCompare);
  return sortedProjects.map((prj, index) => {
    const rowProps = {
      name: prj.name,
      onClick: () => onElementClick(prj.key),
      index: prj.key,
      selected: selected.length > 0 && selected.findIndex(projectId => projectId === prj.key) > -1,
      key: prj.key,
      description: prj.description,
      date: moment(prj.createdAt).format('L'),
      size: prj.size,
      style: index % 2 === 0 ? Style.odd : Style.even,
      image: prj.image,
      batchEdit,
      ...prj,
    };

    return <ProjectGridElement {...rowProps} />;
  });
};

const ProjectListGrid = props => (
  <div style={{ display: 'flex', flex: 1 }}>
    <JumperScrollbar
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      }}
      viewStyle={{
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
      }}
      thumbStyle={{
        backgroundColor: 'rgb(145,153,154)',
        width: '10px',
        cursor: 'pointer',
      }}
    >
      {renderProjectList(props)}
    </JumperScrollbar>
  </div>
);

ProjectListGrid.propTypes = {};

export default Radium(ProjectListGrid);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListGrid/ProjectListGrid.js